import Accordion from 'react-bootstrap/Accordion';
import React, {FormEvent, useEffect, useState} from 'react';
import { AccordionButton } from 'react-bootstrap';
import {Multiselect} from "multiselect-react-dropdown";
import {
    getAPIAccountingFamilyFilter,
    getAPIAgentFilter,
    getAPIAreaFilter,
    getAPICategoryFilter,
    getAPICentralFilter,
    getAPIChannelFilter, getAPICommercialFamilyFilter, getAPIDistanceFilter,
    getAPIDistrictFilter, getAPIEventFilter,
    getAPIGroupFilter,
    getAPILocalityFilter, getAPIMacroFamilyFilter, getAPIPalladinoFilter, getAPIProductFilter,
    getAPIProvinceFilter,
    getAPIRegionFilter, getAPISalesFilter,
    getAPISignFilter,
    getAPISocietyFilter,
    getAPISubCategoryFilter,
    getAPISuperCentralFilter, getAPITastingFilter, getAPITradeCategoryFilter
} from "../services/FilterAPI";
import {BasicItem, PositionMarkerApiRequest} from "../models/PositionMarkerModel"; //MS 14/03: unica maniera per formattare il picker-> usare un componente custom 

export interface FilterPanelProps{
    submitForm: (filters: PositionMarkerApiRequest) => void;
}

//Questo comeponente rappresenta il pannello dei filtri della nostra applicazione
export const FilterPanel: React.FC<FilterPanelProps> = ({submitForm}) => {
    const [societyFilterOptions, setSocietyOptions] = useState<BasicItem[]>([]);
    const [societyFilterOptionsSelected, setSocietyOptionsSelected] = useState<BasicItem[]>([]);
    const [areaFilterOptions, setAreaOptions] = useState<BasicItem[]>([]);
    const [areaFilterOptionsSelected, setAreaOptionsSelected] = useState<BasicItem[]>([]);
    const [districtFilterOptions, setDistrictOptions] = useState<BasicItem[]>([]);
    const [districtFilterOptionsSelected, setDistrictOptionsSelected] = useState<BasicItem[]>([]);
    const [agentFilterOptions, setAgentOptions] = useState<BasicItem[]>([]);
    const [agentFilterOptionsSelected, setAgentOptionsSelected] = useState<BasicItem[]>([]);
    const [channelFilterOptions, setChannelOptions] = useState<BasicItem[]>([]);
    const [channelFilterOptionsSelected, setChannelOptionsSelected] = useState<BasicItem[]>([]);
    const [categoryFilterOptions, setCategoryOptions] = useState<BasicItem[]>([]);
    const [categoryFilterOptionsSelected, setCategoryOptionsSelected] = useState<BasicItem[]>([]);
    const [subCategoryFilterOptions, setSubCategoryOptions] = useState<BasicItem[]>([]);
    const [subCategoryFilterOptionsSelected, setSubCategoryOptionsSelected] = useState<BasicItem[]>([]);
    const [centralFilterOptions, setCentralOptions] = useState<BasicItem[]>([]);
    const [centralFilterOptionsSelected, setCentralOptionsSelected] = useState<BasicItem[]>([]);
    const [superCentralFilterOptions, setSuperCentralOptions] = useState<BasicItem[]>([]);
    const [superCentralFilterOptionsSelected, setSuperCentralOptionsSelected] = useState<BasicItem[]>([]);
    const [signFilterOptions, setSignOptions] = useState<BasicItem[]>([]);
    const [signFilterOptionsSelected, setSignOptionsSelected] = useState<BasicItem[]>([]);
    const [groupFilterOptions, setGroupOptions] = useState<BasicItem[]>([]);
    const [tastingFilterOptions, setTastingOptions] = useState<BasicItem[]>([]);
    const [tastingFilterOptionsSelected, setTastingOptionsSelected] = useState<BasicItem[]>([]);
    const [palladinoFilterOptions, setPalladinoOptions] = useState<BasicItem[]>([]);
    const [palladinoFilterOptionsSelected, setPalladinoOptionsSelected] = useState<BasicItem[]>([]);
    const [eventFilterOptions, setEventOptions] = useState<BasicItem[]>([]);
    const [eventFilterOptionsSelected, setEventOptionsSelected] = useState<BasicItem[]>([]);
    const [groupFilterOptionsSelected, setGroupOptionsSelected] = useState<BasicItem[]>([]);
    const [regionFilterOptions, setRegionOptions] = useState<BasicItem[]>([]);
    const [regionFilterOptionsSelected, setRegionOptionsSelected] = useState<BasicItem[]>([]);
    const [provinceFilterOptions, setProvinceOptions] = useState<BasicItem[]>([]);
    const [provinceFilterOptionsSelected, setProvinceOptionsSelected] = useState<BasicItem[]>([]);
    const [localityFilterOptions, setLocalityOptions] = useState<BasicItem[]>([]);
    const [localityFilterOptionsSelected, setLocalityOptionsSelected] = useState<BasicItem[]>([]);
    const [macroFamilyFilterOptions, setmacroFamilyOptions] = useState<BasicItem[]>([]);
    const [macroFamilyFilterOptionsSelected, setmacroFamilyOptionsSelected] = useState<BasicItem[]>([]);
    const [tradeCategotyFilterOptions, setTradeCategotyOptions] = useState<BasicItem[]>([]);
    const [tradeCategotyFilterOptionsSelected, setTradeCategotyOptionsSelected] = useState<BasicItem[]>([]);
    const [accountingFamilyFilterOptions, setAccountingFamilyOptions] = useState<BasicItem[]>([]);
    const [accountingFamilyFilterOptionsSelected, setAccountingFamilyOptionsSelected] = useState<BasicItem[]>([]);
    const [commercialFamilyFilterOptions, setcommercialFamilyOptions] = useState<BasicItem[]>([]);
    const [commercialFamilyFilterOptionsSelected, setcommercialFamilyOptionsSelected] = useState<BasicItem[]>([]);
    const [productFilterOptions, setProductOptions] = useState<BasicItem[]>([]);
    const [productFilterOptionsSelected, setProductOptionsSelected] = useState<BasicItem[]>([]);
    const [salesFilterOptions, setSalesOptions] = useState<BasicItem[]>([]);
    const [salesFilterOptionsSelected, setSalesOptionsSelected] = useState<BasicItem[]>([]);
    const [yearFilterOptions, setYearOptions] = useState<BasicItem[]>([]);
    const [yearFilterOptionSelected, setYearOptionsSelected] = useState<BasicItem[]>([]);
    const [monthFilterOptions, setMonthOptions] = useState<BasicItem[]>([]);
    const [monthFilterOptionsSelected, setMonthOptionsSelected] = useState<BasicItem[]>([]);
    const [weekFilterOptions, setWeekOptions] = useState<BasicItem[]>([]);
    const [weekFilterOptionsSelected, setWeekOptionsSelected] = useState<BasicItem[]>([]);
    const [isCheckedFilterDegustazione, setIsChecked] = useState(false);
    const [isCheckedFilterPalladino, setIsPalladinoChecked] = useState(false);
    const [isCheckedFilterEvento, setIsEventoChecked] = useState(false);
    const [distanceFilterOptions, setDistanceOptions] = useState<BasicItem[]>([]);
    const [distanceFilterOptionsSelected, setDistanceOptionsSelected] = useState<BasicItem[]>([]);
    const [activeKeyAccordion, setActiveKeyAccordion] = useState("1");

    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;

    const closeAccordion = () => {
        setActiveKeyAccordion("1");
    };

    const clickAccordion = () => {
        if(activeKeyAccordion == "0")
            setActiveKeyAccordion("1");
        
        if(activeKeyAccordion == "1")
            setActiveKeyAccordion("0");
    };
    
    const handleSocietySelect = (selectedList : any) => {
        setSocietyOptionsSelected(selectedList);
        
        initializeData(selectedList);
    };

    const handleAreaSelect = (selectedList : any) => {
        setAreaOptionsSelected(selectedList);
    };

    const handleDistrictSelect = (selectedList : any) => {
        setDistrictOptionsSelected(selectedList);
    };

    const handleAgentSelect = (selectedList : any) => {
        setAgentOptionsSelected(selectedList);
    };

    const handleChannelSelect = (selectedList : any) => {
        setChannelOptionsSelected(selectedList);
    };

    const handleCategorySelect = (selectedList : any) => {
        setCategoryOptionsSelected(selectedList);
    };

    const handleSubCategorySelect = (selectedList : any) => {
        setSubCategoryOptionsSelected(selectedList);
    };

    const handleCentralSelect = (selectedList : any) => {
        setCentralOptionsSelected(selectedList);
    };

    const handleSuperCentralSelect = (selectedList : any) => {
        setSuperCentralOptionsSelected(selectedList);
    };

    const handleSignSelect = (selectedList : any) => {
        setSignOptionsSelected(selectedList);
    };

    const handleGroupSelect = (selectedList : any) => {
        setGroupOptionsSelected(selectedList);
    };
    const handleTastingSelect = (selectedList : any) => {
        setTastingOptionsSelected(selectedList);
    };
    const handlePalladinoSelect = (selectedList : any) => {
        setPalladinoOptionsSelected(selectedList);
    };
    const handleEventSelect = (selectedList : any) => {
        setEventOptionsSelected(selectedList);
    };

    const handleRegionSelect = (selectedList : any) => {
        setRegionOptionsSelected(selectedList);
    };

    const handleProvinceSelect = (selectedList : any) => {
        setProvinceOptionsSelected(selectedList);
    };

    const handleLocalitySelect = (selectedList : any) => {
        setLocalityOptionsSelected(selectedList);
    };

    const handleMacroFamilySelect = (selectedList : any) => {
        setmacroFamilyOptionsSelected(selectedList);
    };

    const handleTradeCategorySelect = (selectedList : any) => {
        setTradeCategotyOptionsSelected(selectedList);
    };

    const handleAccountingFamilySelect = (selectedList : any) => {
        setAccountingFamilyOptionsSelected(selectedList);
    };

    const handleCommercialFamilySelect = (selectedList : any) => {
        setcommercialFamilyOptionsSelected(selectedList);
    };

    const handleProductSelect = (selectedList : any) => {
        setProductOptionsSelected(selectedList);
    };

    const handleSalesSelect = (selectedList : any) => {
        setSalesOptionsSelected(selectedList);
    };

    const handleDistanceSelect = (selectedList : any) => {
        setDistanceOptionsSelected(selectedList);
    };

    const handleYearSelect = (selectedList : any) => {
        setYearOptionsSelected(selectedList);
    };

    const handleMonthSelect = (selectedList : any) => {
        setMonthOptionsSelected(selectedList);
    };

    const handleWeekSelect = (selectedList : any) => {
        setWeekOptionsSelected(selectedList);
    };
    
    //Setto il della selezione dell'azienda predefinita
    React.useEffect(() => {
        const fetchData = async () => {
            
            const societyResult = await getAPISocietyFilter();
            if (societyResult) {
                setSocietyOptions(societyResult.data);
            }

            const _selectedList : BasicItem[]  =  [{ id: currentYear.toString(), description: currentYear.toString(), companyKey:0 }]
            if (_selectedList.length >0) {
                setYearOptionsSelected(_selectedList);
            }

            await initializeData(null);
        };
        
        // Chiama la funzione
        fetchData();
    },[])
    
    
    async function initializeData(societyFilter : BasicItem[] | null){
        const areaResult = await getAPIAreaFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (areaResult) {
            setAreaOptions(areaResult.data);
        }
        const districtResult = await getAPIDistrictFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (districtResult) {
            setDistrictOptions(districtResult.data);
        }

        const agentResult = await getAPIAgentFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (agentResult) {
            setAgentOptions(agentResult.data);
        }

        const channelResult = await getAPIChannelFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (channelResult) {
            setChannelOptions(channelResult.data);
        }

        const categoryResult = await getAPICategoryFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (categoryResult) {
            setCategoryOptions(categoryResult.data);
        }

        const subCategoryResult = await getAPISubCategoryFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (subCategoryResult) {
            setSubCategoryOptions(subCategoryResult.data);
        }

        const centralResult = await getAPICentralFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (centralResult) {
            setCentralOptions(centralResult.data);
        }

        const superCentralResult = await getAPISuperCentralFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (superCentralResult) {
            setSuperCentralOptions(superCentralResult.data);
        }

        const signResult = await getAPISignFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (signResult) {
            setSignOptions(signResult.data);
        }

        const groupResult = await getAPIGroupFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (groupResult) {
            setGroupOptions(groupResult.data);
        }
        const tastingResult = await getAPITastingFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (tastingResult) {
            setTastingOptions(tastingResult.data);
        }

        const palladinoResult = await getAPIPalladinoFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (palladinoResult) {
            setPalladinoOptions(palladinoResult.data);
        }

        const eventResult = await getAPIEventFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (eventResult) {
            setEventOptions(eventResult.data);
        }

        const regionResult = await getAPIRegionFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (regionResult) {
            setRegionOptions(regionResult.data);
        }

        const provinceResult = await getAPIProvinceFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (provinceResult) {
            setProvinceOptions(provinceResult.data);
        }

        const localityResult = await getAPILocalityFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (localityResult) {
            setLocalityOptions(localityResult.data);
        }

        const macroFamilyResult = await getAPIMacroFamilyFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (macroFamilyResult) {
            setmacroFamilyOptions(macroFamilyResult.data);
        }

        const tradeCategoryResult = await getAPITradeCategoryFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (tradeCategoryResult) {
            setTradeCategotyOptions(tradeCategoryResult.data);
        }

        const accountingFamilyResult = await getAPIAccountingFamilyFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (accountingFamilyResult) {
            setAccountingFamilyOptions(accountingFamilyResult.data);
        }

        const commercialFamilyResult = await getAPICommercialFamilyFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (commercialFamilyResult) {
            setcommercialFamilyOptions(commercialFamilyResult.data);
        }

        const productResult = await getAPIProductFilter(societyFilter?.map(item => item.id).join(',') ?? null);
        if (productResult) {
            setProductOptions(productResult.data);
        }

        const salesResult = await getAPISalesFilter();
        if (salesResult) {
            setSalesOptions(salesResult.data);
        }

        const distanceResult = await getAPIDistanceFilter();
        if (distanceResult) {
            setDistanceOptions(distanceResult.data);
        }

        const years : BasicItem[] = [
            { id: currentYear.toString(), description: currentYear.toString(), companyKey:0 },
            { id: previousYear.toString(), description: previousYear.toString(), companyKey:0 }
        ];

        setYearOptions(years);

        const months: BasicItem[] = [
            { id: "01", description: 'Gennaio', companyKey:0 },
            { id: "02", description: 'Febbraio', companyKey:0},
            { id: "03", description: 'Marzo', companyKey:0 },
            { id: "04", description: 'Aprile', companyKey:0 },
            { id: "05", description: 'Maggio', companyKey:0 },
            { id: "06", description: 'Giugno', companyKey:0 },
            { id: "07", description: 'Luglio', companyKey:0 },
            { id: "08", description: 'Agosto', companyKey:0 },
            { id: "09", description: 'Settembre', companyKey:0 },
            { id: "10", description: 'Ottobre', companyKey:0 },
            { id: "11", description: 'Novembre', companyKey:0 },
            { id: "12", description: 'Dicembre', companyKey:0 }
        ];

        setMonthOptions(months);


        const week: BasicItem[] = Array.from({ length: 52 }, (_, i) => ({
            id: i < 9 ? "0"+(i + 1).toString() : (i + 1).toString(),
            description: (i + 1).toString(),
            companyKey: 0
        }));

        setWeekOptions(week);
    }

    const handleCheckboxChange = (event : any) => {
        setIsChecked(event.target.checked);
    };

    const handlePalladinoCheckboxChange = (event : any) => {
        setIsPalladinoChecked(event.target.checked);
    };

    const handleEventoCheckboxChange = (event : any) => {
        setIsEventoChecked(event.target.checked);
    };

    const submitHandler = (evt: FormEvent) => {
        evt.preventDefault(); //permette alla pagina di non essere ricaricata al click sul load
        
        submitForm({
            societyListId : societyFilterOptionsSelected.map(item => item.id).join(','),
            areaListId : areaFilterOptionsSelected.map(item => item.id).join(','),
            districtListId : districtFilterOptionsSelected.map(item => item.id).join(','),
            agentListId : agentFilterOptionsSelected.map(item => item.id).join(','),
            channelListId : channelFilterOptionsSelected.map(item => item.id).join(','),
            categoryListId : categoryFilterOptionsSelected.map(item => item.id).join(','),
            subCategoryListId : subCategoryFilterOptionsSelected.map(item => item.id).join(','),
            palladino :  palladinoFilterOptionsSelected.map(item => item.id).join(','),
            centralListId :  centralFilterOptionsSelected.map(item => item.id).join(','),
            superCentralListId : superCentralFilterOptionsSelected.map(item => item.id).join(','),
            signListId : signFilterOptionsSelected.map(item => item.id).join(','),
            groupListId : groupFilterOptionsSelected.map(item => item.id).join(','),
            tasting : tastingFilterOptionsSelected.map(item => item.id).join(','),
            event : eventFilterOptionsSelected.map(item => item.id).join(','),
            regionListId : regionFilterOptionsSelected.map(item => item.id).join(','),
            provinceListId : provinceFilterOptionsSelected.map(item => item.id).join(','),
            localityListId : localityFilterOptionsSelected.map(item => item.id).join(','),
            macroFamilyId :  macroFamilyFilterOptionsSelected.map(item => item.id).join(','),
            tradeCategoryId : tradeCategotyFilterOptionsSelected.map(item => item.id).join(','),
            accountingFamilyId : accountingFamilyFilterOptionsSelected.map(item => item.id).join(','),
            commercialFamilyId : commercialFamilyFilterOptionsSelected.map(item => item.id).join(','),
            productListId : productFilterOptionsSelected.map(item => item.id).join(','),
            year : yearFilterOptionSelected?.length > 0 ? +(yearFilterOptionSelected[0].id) : null,
            monthListId : monthFilterOptionsSelected.map(item => item.id).join(','),
            weekListId : weekFilterOptionsSelected.map(item => item.id).join(','),
            salesListId : salesFilterOptionsSelected.map(item => item.id).join(','),
            distance : distanceFilterOptionsSelected?.length > 0 ? +(distanceFilterOptionsSelected[0].id) : null,
        } as PositionMarkerApiRequest);

        closeAccordion();
      };

    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: '10px', position:"absolute", left: '-10px', width: '50%'}}>
            <Accordion defaultActiveKey="0" className="accordionClass" activeKey={activeKeyAccordion}>
                <Accordion.Item eventKey="0">
                    <AccordionButton className="App-title" onClick={clickAccordion}>Scegli filtri 
                    </AccordionButton>
                    <Accordion.Body style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col my-auto">
                                    <form onSubmit={submitHandler}>
                                        <div className="row form-group">
                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Societa</label>
                                                <Multiselect
                                                    options={societyFilterOptions}
                                                    selectedValues={societyFilterOptionsSelected}
                                                    onSelect={handleSocietySelect}
                                                    onRemove={handleSocietySelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>
                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Area</label>
                                                <Multiselect
                                                    options={areaFilterOptions}
                                                    selectedValues={areaFilterOptionsSelected}
                                                    displayValue="description"
                                                    onSelect={handleAreaSelect}
                                                    onRemove={handleAreaSelect}
                                                    placeholder={""}
                                                />
                                            </div>
                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Distretto</label>
                                                <Multiselect
                                                    options={districtFilterOptions}
                                                    selectedValues={districtFilterOptionsSelected}
                                                    onSelect={handleDistrictSelect}
                                                    onRemove={handleDistrictSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>
                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Agente</label>
                                                <Multiselect
                                                    options={agentFilterOptions}
                                                    selectedValues={agentFilterOptionsSelected}
                                                    onSelect={handleAgentSelect}
                                                    onRemove={handleAgentSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>
                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Canale</label>
                                                <Multiselect
                                                    options={channelFilterOptions}
                                                    selectedValues={channelFilterOptionsSelected}
                                                    onSelect={handleChannelSelect}
                                                    onRemove={handleChannelSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>
                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Categoria</label>
                                                <Multiselect
                                                    options={categoryFilterOptions}
                                                    selectedValues={categoryFilterOptionsSelected}
                                                    onSelect={handleCategorySelect}
                                                    onRemove={handleCategorySelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Sottocategoria</label>
                                                <Multiselect
                                                    options={subCategoryFilterOptions}
                                                    selectedValues={subCategoryFilterOptionsSelected}
                                                    onSelect={handleSubCategorySelect}
                                                    onRemove={handleSubCategorySelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            {/*<div className="col-12 m-2">*/}
                                            {/*    <label style={{fontWeight: 'bold'}}>Palladino</label>*/}
                                            {/*    <Switch*/}
                                            {/*        onChange={handlePalladinoCheckboxChange}*/}
                                            {/*        checked={isCheckedFilterPalladino}*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Paladino</label>
                                                <Multiselect
                                                    options={palladinoFilterOptions}
                                                    selectedValues={palladinoFilterOptionsSelected}
                                                    onSelect={handlePalladinoSelect}
                                                    onRemove={handlePalladinoSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Centrale</label>
                                                <Multiselect
                                                    options={centralFilterOptions}
                                                    selectedValues={centralFilterOptionsSelected}
                                                    onSelect={handleCentralSelect}
                                                    onRemove={handleCentralSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Supercentrale</label>
                                                <Multiselect
                                                    options={superCentralFilterOptions}
                                                    selectedValues={superCentralFilterOptionsSelected}
                                                    onSelect={handleSuperCentralSelect}
                                                    onRemove={handleSuperCentralSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Insegna</label>
                                                <Multiselect
                                                    options={signFilterOptions}
                                                    selectedValues={signFilterOptionsSelected}
                                                    onSelect={handleSignSelect}
                                                    onRemove={handleSignSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Gruppo</label>
                                                <Multiselect
                                                    options={groupFilterOptions}
                                                    selectedValues={groupFilterOptionsSelected}
                                                    onSelect={handleGroupSelect}
                                                    onRemove={handleGroupSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            {/*<div className="col-12 m-2">*/}
                                            {/*    <label style={{fontWeight: 'bold'}}>Degustazione</label>*/}

                                            {/*    <Switch*/}
                                            {/*        onChange={handleCheckboxChange}*/}
                                            {/*        checked={isCheckedFilterDegustazione}*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Degustazione</label>
                                                <Multiselect
                                                    options={tastingFilterOptions}
                                                    selectedValues={tastingFilterOptionsSelected}
                                                    onSelect={handleTastingSelect}
                                                    onRemove={handleTastingSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            {/*<div className="col-12 m-2">*/}
                                            {/*    <label style={{fontWeight: 'bold'}}>Evento</label>*/}
                                            {/*    <Switch*/}
                                            {/*        onChange={handleEventoCheckboxChange}*/}
                                            {/*        checked={isCheckedFilterEvento}*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Evento</label>
                                                <Multiselect
                                                    options={eventFilterOptions}
                                                    selectedValues={eventFilterOptionsSelected}
                                                    onSelect={handleEventSelect}
                                                    onRemove={handleEventSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Regione</label>
                                                <Multiselect
                                                    options={regionFilterOptions}
                                                    selectedValues={regionFilterOptionsSelected}
                                                    onSelect={handleRegionSelect}
                                                    onRemove={handleRegionSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Provincia</label>
                                                <Multiselect
                                                    options={provinceFilterOptions}
                                                    selectedValues={provinceFilterOptionsSelected}
                                                    onSelect={handleProvinceSelect}
                                                    onRemove={handleProvinceSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Località</label>
                                                <Multiselect
                                                    options={localityFilterOptions}
                                                    selectedValues={localityFilterOptionsSelected}
                                                    onSelect={handleLocalitySelect}
                                                    onRemove={handleLocalitySelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Macrofamiglia</label>
                                                <Multiselect
                                                    options={macroFamilyFilterOptions}
                                                    selectedValues={macroFamilyFilterOptionsSelected}
                                                    onSelect={handleMacroFamilySelect}
                                                    onRemove={handleMacroFamilySelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Categoria trade</label>
                                                <Multiselect
                                                    options={tradeCategotyFilterOptions}
                                                    selectedValues={tradeCategotyFilterOptionsSelected}
                                                    onSelect={handleTradeCategorySelect}
                                                    onRemove={handleTradeCategorySelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Famiglia contabile</label>
                                                <Multiselect
                                                    options={accountingFamilyFilterOptions}
                                                    selectedValues={accountingFamilyFilterOptionsSelected}
                                                    onSelect={handleAccountingFamilySelect}
                                                    onRemove={handleAccountingFamilySelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Famiglia commerciale</label>
                                                <Multiselect
                                                    options={commercialFamilyFilterOptions}
                                                    selectedValues={commercialFamilyFilterOptionsSelected}
                                                    onSelect={handleCommercialFamilySelect}
                                                    onRemove={handleCommercialFamilySelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Prodotto</label>
                                                <Multiselect
                                                    options={productFilterOptions}
                                                    selectedValues={productFilterOptionsSelected}
                                                    onSelect={handleProductSelect}
                                                    onRemove={handleProductSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Anno</label>
                                                <Multiselect
                                                    singleSelect={true}
                                                    options={yearFilterOptions}
                                                    selectedValues={yearFilterOptionSelected}
                                                    onSelect={handleYearSelect}
                                                    onRemove={handleYearSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Mese</label>
                                                <Multiselect
                                                    options={monthFilterOptions}
                                                    selectedValues={monthFilterOptionsSelected}
                                                    onSelect={handleMonthSelect}
                                                    onRemove={handleMonthSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Settimana</label>
                                                <Multiselect
                                                    options={weekFilterOptions}
                                                    selectedValues={weekFilterOptionsSelected}
                                                    onSelect={handleWeekSelect}
                                                    onRemove={handleWeekSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Fatturato</label>
                                                <Multiselect
                                                    options={salesFilterOptions}
                                                    selectedValues={salesFilterOptionsSelected}
                                                    onSelect={handleSalesSelect}
                                                    onRemove={handleSalesSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>

                                            <div className="col-12 m-2">
                                                <label style={{fontWeight: 'bold'}}>Distanza</label>
                                                <Multiselect
                                                    singleSelect={true}
                                                    options={distanceFilterOptions}
                                                    selectedValues={distanceFilterOptionsSelected}
                                                    onSelect={handleDistanceSelect}
                                                    onRemove={handleDistanceSelect}
                                                    displayValue="description"
                                                    placeholder={""}
                                                />
                                            </div>
                                        </div>

                                        <div className="row form-group">
                                            <div className="col-12 m-2">
                                                <button type="submit" className="btn btn-secondary w-100">
                                                    Cerca
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    );
};